import { Component, OnInit, ElementRef, ViewChild, Injector } from '@angular/core';

import { FormGroup, FormBuilder, ValidationErrors, Validators, FormControl, ValidatorFn, AbstractControl } from "@angular/forms";

import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Constants } from 'src/app/util/Constants';

import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/UserService';
import { PasswordValidator } from 'src/app/validator/PasswordValidator';
import { BaseComponent } from '../../common/BaseComponent';
import { ProgressService } from 'src/app/service/ProgressService';
import { environment } from 'src/environments/environment';
import { BpsEmailValidator } from 'src/app/validator/BpsEmailValidator';
@Component({
  selector: 'app-set-new-password',
  templateUrl: './set-new-password.component.html',
  styles: [`
  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }
`]
})
export class SetNewPasswordComponent extends BaseComponent implements OnInit {

  passwordResetForm: FormGroup;
  restSub: Subscription;
  submitted: boolean;
  showPasswordNew: boolean = false;
  showPasswordConfirm: boolean = false;
  showPasswordTemp: boolean = false;
  password: string;
  appErrorPrefix: string = "bss.api.error";
  user: User;
  resendDisabled: boolean = false;
  pageMsgRendered: boolean;
  // emailAccess: boolean;
  @ViewChild('pageMsg') pageMsgElement: ElementRef;
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;

  constructor(
    injector: Injector,
    public rest: UserService,
    public progressService: ProgressService,
    public fb: FormBuilder) {
    super(injector);
    this.submitted = false;
    this.pageMsgRendered = false;
  }

  togglePasswordTemp() {
    this.showPasswordTemp = !this.showPasswordTemp;
  }
  togglePasswordNew() {
    this.showPasswordNew = !this.showPasswordNew;
  }

  togglePasswordConfirm() {
    this.showPasswordConfirm = !this.showPasswordConfirm;
  }

  ngAfterViewInit() {
    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
  }

  ngAfterViewChecked() {
    if (!this.pageMsgRendered && this.pageMsgElement !== undefined) {
      this.pageMsgElement.nativeElement.focus();
      this.pageMsgElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.pageMsgRendered = true;
    }
  }

  ngOnInit(): void {

    const sessionUser = sessionStorage.getItem("user");
    // console.log(sessionUser);
    this.user = JSON.parse(sessionUser);
    // this.emailAccess = this.user.emailAccess;
    // console.log(this.user);

    this.passwordResetForm = new FormGroup({
      email: new FormControl(null, Validators.compose([Validators.required, PasswordValidator.invalidEmail, BpsEmailValidator.restricted])),
      tempPassword: new FormControl(null,
        Validators.compose([
          Validators.required
        ])
      ),
      newPassword: new FormControl(null,
        Validators.compose([
          Validators.required, PasswordValidator.startC, PasswordValidator.strongU,
          PasswordValidator.strongL, PasswordValidator.strongD, PasswordValidator.strongS, PasswordValidator.strongDS, PasswordValidator.strongR,
          Validators.maxLength(17), Validators.minLength(12)
        ])
      ),
      confirmNewPassword: new FormControl(null,
        Validators.compose([
          Validators.required, PasswordValidator.startC, PasswordValidator.strongU,
          PasswordValidator.strongL, PasswordValidator.strongD, PasswordValidator.strongS, PasswordValidator.strongR, Validators.maxLength(17), Validators.minLength(12)]))
    }, {
      validators: [
        PasswordValidator.matchValidator('newPassword', 'confirmNewPassword'),
        // PasswordValidator.passwordUserContainsFName(this.user.firstName, 'newPassword'),
        // PasswordValidator.passwordUserContainsLName(this.user.lastName, 'newPassword'),
        PasswordValidator.newpasswordUserContainsEmail( 'newPassword','email')
      ]
    });

  }

  onSubmit(): void {
    this.submitted = true;
    this.pageMsgRendered = false;
    // console.log("submitted");

    if (this.passwordResetForm.valid) {
      this.isSubmitting = true;
      // const sessionUser = sessionStorage.getItem("user");
      // let user = JSON.parse(sessionUser);
      let setUser = new User();
      this.progressService.open();
      setUser.email = this.passwordResetForm.get("email").value;
      setUser.temporaryPassword = this.passwordResetForm.get("tempPassword").value;
      setUser.newPassword = this.passwordResetForm.get("newPassword").value;
      setUser.confirmNewPassword = this.passwordResetForm.get("confirmNewPassword").value;
      // user.otp = Constants.DEFAULT_OTP ;
      
      // console.log(JSON.stringify(setUser));
      this.restSub = this.rest.setNewPassword(setUser).subscribe(response => {
        console.log("get-data:" + JSON.stringify(response));
        this.isSubmitting = false;
        if (response.result > 0) {
          this.appError = true;
          this.appSuccess = false;
          this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;

          //handle account locked situation
          this.checkIfAccountLocked(response.error_code);
        } else {
          this.appError = false;
          this.appSuccess = true;
          this.clearSession();
          this.router.navigate(['public/password/reset/success']);
        }
      }, (error) => {
        this.processError(error);
      },
        () => {
          this.progressService.close();
        });
    }
  }

  clearSession() {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("loginEmail");    
    //Fix for #25469, we don't clear resource_url here since on scucess page we still need it
    //sessionStorage.removeItem("resource_url");
  }

  onCancel(): void {
    this.router.navigate(['public/logout']);
  }

  ngOnDestroy() {
    if (this.restSub) {
      this.restSub.unsubscribe();
    }
  }
}